import { styled } from '@mui/material/styles';
const PREFIX = 'CustomSortableTable';
export const classes = {
    root: `${PREFIX}-root`,
    paper: `${PREFIX}-paper`,
    table: `${PREFIX}-table`,
    toolbar: `${PREFIX}-toolbar`,
    toolbarContainer: `${PREFIX}-toolbarContainer`,
    toolbarTitleContainer: `${PREFIX}-toolbarTitleContainer`,
    toolbarActionsContainer: `${PREFIX}-toolbarActionsContainer`,
    footer: `${PREFIX}-footer`,
    footerActionsContainer: `${PREFIX}-footerActionsContainer`,
    footerLabel: `${PREFIX}-footerLabel`,
    collapsibleHeader: `${PREFIX}-collapsibleHeader`,
    title: `${PREFIX}-title`,
    counter: `${PREFIX}-counter`,
    visuallyHidden: `${PREFIX}-visuallyHidden`,
    collapseCell: `${PREFIX}-collapseCell`,
    totalCell: `${PREFIX}-totalCell`,
    collapsibleRowItem: `${PREFIX}-collapsibleRowItem`,
    lastCollapsibleCell: `${PREFIX}-lastCollapsibleCell`,
    tableHeaderNoRows: `${PREFIX}-tableHeaderNoRows`,
    tableRow: `${PREFIX}-tableRow`,
    lastRow: `${PREFIX}-lastRow`,
    disabled: `${PREFIX}-disabled`,
    formControlLabel: `${PREFIX}-formControlLabel`,
    actionsContainer: `${PREFIX}-actionsContainer`,
    filterPaper: `${PREFIX}-filterPaper`,
    filtersTitle: `${PREFIX}-filtersTitle`,
    filter: `${PREFIX}-filter`,
    searchButton: `${PREFIX}-searchButton`,
    destructiveButton: `${PREFIX}-destructiveButton`,
};
const Root = styled('div')(({ theme }) => ({
    [`&.${classes.root}`]: {},
    [`& .${classes.paper}`]: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    [`& .${classes.table}`]: {
        minWidth: 750,
    },
    [`& .${classes.toolbar}`]: {
        marginTop: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
    },
    [`& .${classes.toolbarContainer}`]: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
    },
    [`& .${classes.toolbarTitleContainer}`]: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    [`& .${classes.toolbarActionsContainer}`]: {
        display: 'flex',
        justifyContent: 'flex-end',
        '& > button': {
            marginLeft: theme.spacing(1),
        },
    },
    [`& .${classes.footer}`]: {
        marginTop: theme.spacing(2),
    },
    [`& .${classes.footerActionsContainer}`]: {
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
        '& > button': {
            marginLeft: theme.spacing(1),
        },
    },
    [`& .${classes.footerLabel}`]: {
        marginLeft: theme.spacing(2),
    },
    [`& .${classes.collapsibleHeader}`]: {
        display: 'flex',
        position: 'relative',
        alignItems: 'center',
        [`& > ${classes.counter}`]: {
            width: theme.spacing(4),
            height: theme.spacing(4),
        },
    },
    [`& .${classes.title}`]: {
        flexGrow: 1,
    },
    [`& .${classes.counter}`]: {
        marginRight: theme.spacing(2),
    },
    [`& .${classes.visuallyHidden}`]: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    [`& .${classes.collapseCell}`]: {
        width: 60,
    },
    [`& .${classes.totalCell}`]: {
        fontWeight: 'bold',
    },
    [`& .${classes.lastCollapsibleCell}`]: {
        borderBottom: 0,
    },
    [`& .${classes.collapsibleRowItem}`]: {
        borderBottomWidth: 0,
        '& td': {},
        [`& + ${classes.tableRow}, + ${classes.lastRow}`]: {
            borderTopWidth: 1,
            borderTopColor: theme.palette.divider,
            borderTopStyle: 'solid',
        },
    },
    [`& .${classes.tableHeaderNoRows}`]: {
        '&:last-of-type': {
            borderBottomWidth: 0,
            '& th': {
                borderBottomWidth: 0,
            },
        },
    },
    [`& .${classes.tableRow}`]: {
        borderBottomWidth: 0,
    },
    [`& .${classes.lastRow}`]: {
        borderBottomWidth: 0,
        '& td': {
            borderBottomWidth: 0,
        },
    },
    [`& .${classes.disabled}`]: {
        // textDecoration: 'line-through',
        opacity: 0.6,
    },
    [`& .${classes.formControlLabel}`]: {
        marginBottom: theme.spacing(2),
    },
    [`& .${classes.actionsContainer}`]: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginRight: theme.spacing(2),
        '& > button': {
            marginLeft: theme.spacing(1),
        },
    },
    [`& .${classes.filterPaper}`]: {
        width: '100%',
        marginTop: theme.spacing(2),
        padding: theme.spacing(2),
    },
    [`& .${classes.filtersTitle}`]: {
        marginBottom: theme.spacing(1),
    },
    [`& .${classes.filter}`]: {
        marginRight: theme.spacing(4),
        '&:last-of-type': {
            marginRight: 0,
        },
    },
    [`& .${classes.searchButton}`]: {
        cursor: 'pointer',
        width: 24,
        height: 24,
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    [`& .${classes.destructiveButton}`]: {
        color: theme.palette.error.main,
        borderColor: theme.palette.error.main,
        backgroundColor: theme.palette.background.paper,
        '&:hover': {
            color: theme.palette.error.contrastText,
            // backgroundColor: theme.palette.error.dark,
        },
    },
}));
export default Root;
//# sourceMappingURL=styled.js.map